<template>
    <ul>
        <li v-for="item in playlist"
            v-bind:data="item"
            v-bind:key="item.id"
            v-on:click="$emit('select-song', item)"
        >
            <span>{{item.song}} {{item.artist}}</span>
        </li>
    </ul>
</template>

<script>
    export default {
        name: "Playlist",
        data() {
            return {}
        },
        props: ['playlist', 'selected']
    }
</script>

<style scoped>
    ul {
        text-align: center;
        padding: 0;
    }

    li {
        text-decoration: none;
        list-style-type: none;
        padding: 5px 0;
    }

    li {
        cursor: pointer;
    }

    li:hover > span {
        color: white;
    }

    li:nth-child(even) {
        background-color: rgba(6, 23, 37, 0.15);
    }

    li:hover {
        background-color: black;
    }

    li.active {
        background-color: black;
    }

    /*li:nth-child(odd):hover {*/
        /*background-color: rgba(6, 23, 37, 0.1);*/
    /*}*/

</style>
